import { Button } from "@/components/ui/button";
import {
	Drawer,
	DrawerContentWithoutCancelButton,
} from "@/components/ui/dropdownMobile";
import { Link } from "@tanstack/react-router";
import websiteIllustration from "../../assets/website_Illustration.png";

// Drawer state types
export type CourseDrawerState = {
	open: boolean;
	step: "go_to_login" | "go_to_website";
	selectedCourse: { title: string; description: string } | null;
};

export type CourseDrawerAction =
	| { type: "OPEN_DRAWER"; payload: { title: string; description: string } }
	| { type: "CLOSE_DRAWER" }
	| { type: "SET_STEP"; payload: "go_to_login" | "go_to_website" };

interface CourseAccessDrawerComponentProps {
	state: CourseDrawerState;
	onOpenChange: (open: boolean) => void;
	onCloseDrawer: () => void;
	onOpenWebsite: () => void;
}

export const CourseAccessDrawer = ({
	state,
	onOpenChange,
	onCloseDrawer,
	onOpenWebsite,
}: CourseAccessDrawerComponentProps): JSX.Element => {
	return (
		<Drawer open={state.open} onOpenChange={onOpenChange}>
			<DrawerContentWithoutCancelButton>
				<div className="m-10 text-center">
					{state.step === "go_to_login" && (
						<>
							<img
								alt="website ilustration"
								className="mx-auto w-[130px] h-auto"
								src={websiteIllustration}
							/>
							{state.selectedCourse && (
								<>
									<h2 className="text-xl font-bold text-center my-4">
										{state.selectedCourse.title}
									</h2>
									<p className="text-[#637381] mb-6">
										{state.selectedCourse.description}
									</p>
								</>
							)}
							<h3 className="text-lg text-[#637381] pb-4 text-center mb-6">
								Czy chcesz się zalogować żeby sprawdzić dostępność?
							</h3>
							<div className="flex justify-around">
								<Button
									className="w-[150px] h-[50px] bg-[#919EAB14] text-black"
									onClick={onCloseDrawer}
								>
									NIE
								</Button>
								<Link to="/login">
									<Button className="w-[150px] h-[50px]">TAK</Button>
								</Link>
							</div>
						</>
					)}
					{state.step === "go_to_website" && (
						<>
							<h3 className="text-lg font-bold text-center mb-10">
								Dostęp do kursu
							</h3>
							{state.selectedCourse && (
								<>
									<h4 className="text-lg font-semibold text-center mb-4">
										{state.selectedCourse.title}
									</h4>
									<p className="text-[#637381] mb-6">
										{state.selectedCourse.description}
									</p>
								</>
							)}
							<p className="text-[#637381] mb-10 font-semibold">
								Na stronie www Akademia LTCA możesz uzyskać dostęp do kursu.
							</p>
							<Button
								className="text-blue-700 text-lg"
								variant="link"
								onClick={onOpenWebsite}
							>
								www.akademialtca.pl
							</Button>
						</>
					)}
				</div>
			</DrawerContentWithoutCancelButton>
		</Drawer>
	);
};
